import { render, staticRenderFns } from "./CoozzyCalendarWeekIcon.vue?vue&type=template&id=0cf1f5aa&scoped=true"
import script from "./CoozzyCalendarWeekIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyCalendarWeekIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyCalendarWeekIcon.vue?vue&type=style&index=0&id=0cf1f5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1f5aa",
  null
  
)

export default component.exports